import {
  ActionIcon,
  Button,
  CloseButton,
  Divider,
  Group,
  Menu,
  Paper,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import {
  IconArrowLeft,
  IconCalendarWeek,
  IconChevronDown,
} from "@tabler/icons-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import {
  getEnrichUsage,
  getEnrichUsageAdmin,
} from "../../../../../api/AdminAPI";
import { DatePickerInput } from "@mantine/dates";
import { useLanguage } from "../../../../../stores/LanguageStore";
import {
  getLastWeekStartAndEnd,
  getLastXMonthsRange,
  getMonthStartAndEnd,
  getWeekStartAndEnd,
} from "../../../../../functions/dates";
import UserSelector from "../../../../../components/UserSelector/UserSelector";
import { useProfileStore } from "../../../../../stores/UserStore";

const EnrichUsage = () => {
  const lang = useLanguage((s) => s.language);
  const [dateRange, setDateRange] = useState({
    start_date: null,
    end_date: null,
  });
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleDateChange = (v) => {
    setDateRange({
      start_date: v[0],
      end_date: v[1],
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    let func =
      useProfileStore.getState().profile?.level === "admin"
        ? getEnrichUsageAdmin
        : getEnrichUsage;
    func({ date_range: dateRange, user_id: user?.id })
      .then((r) => {
        setResult(r.data);
      })
      .finally(() => setLoading(false));
  };

  return (
    <Stack flex={1} pr={48} pt={16} gap={0}>
      <Group gap={"md"}>
        <ActionIcon size={"xl"} component={Link} to={"/settings/tools"}>
          <IconArrowLeft />
        </ActionIcon>
        <Text size="xl" fw={600} mr={"auto"}>
          Statistiques d'enrichissement externe
        </Text>
      </Group>

      <Divider my={16} />

      <Paper p={"lg"} component="form" onSubmit={handleSubmit}>
        <Group>
          <DatePickerInput
            type="range"
            label={lang.reporting.period}
            placeholder={lang.reports.period}
            leftSection={<IconCalendarWeek size={18} />}
            value={[dateRange.start_date, dateRange.end_date]}
            onChange={handleDateChange}
            maxDate={new Date()}
            w={360}
            name="date_range"
            required
            radius={"md"}
            styles={{
              input: {
                borderColor: "var(--mantine-color-primary-0)",
              },
            }}
            valueFormat="DD / MM / YYYY"
            size="md"
            rightSectionWidth={dateRange.start_date ? 75 : 50}
            rightSection={
              <Group gap={"xs"} wrap="nowrap">
                {dateRange.start_date && (
                  <CloseButton
                    onClick={() =>
                      setDateRange({ start_date: null, end_date: null })
                    }
                  />
                )}
                <Menu>
                  <Menu.Target>
                    <Tooltip
                      label={lang.reporting.period_chevron}
                      position="top"
                      disabled
                    >
                      <ActionIcon variant="subtle">
                        <IconChevronDown />
                      </ActionIcon>
                    </Tooltip>
                  </Menu.Target>

                  <Menu.Dropdown>
                    <Menu.Item
                      onClick={() => {
                        let thisWeek = getWeekStartAndEnd(new Date());
                        setDateRange({
                          start_date: thisWeek.weekStart,
                          end_date: thisWeek.weekEnd,
                        });
                      }}
                    >
                      {lang.reporting.period_week}
                    </Menu.Item>
                    <Menu.Item
                      onClick={() => {
                        let result = getLastWeekStartAndEnd(new Date());
                        setDateRange({
                          start_date: result.weekStart,
                          end_date: result.weekEnd,
                        });
                      }}
                    >
                      {lang.reporting.period_last_week}
                    </Menu.Item>
                    <Menu.Item
                      onClick={() => {
                        let thisMonth = getMonthStartAndEnd(new Date());
                        setDateRange({
                          start_date: thisMonth.monthStart,
                          end_date: thisMonth.monthEnd,
                        });
                      }}
                    >
                      {lang.reporting.period_month}
                    </Menu.Item>
                    <Menu.Item
                      onClick={() => {
                        let result = getLastXMonthsRange(new Date(), 3);
                        setDateRange({
                          start_date: result.start,
                          end_date: result.end,
                        });
                      }}
                    >
                      {lang.reporting.period_months.replace("#", "3")}
                    </Menu.Item>
                    <Menu.Item
                      onClick={() => {
                        let result = getLastXMonthsRange(new Date(), 6);
                        setDateRange({
                          start_date: result.start,
                          end_date: result.end,
                        });
                      }}
                    >
                      {lang.reporting.period_months.replace("#", "6")}
                    </Menu.Item>
                  </Menu.Dropdown>
                </Menu>
              </Group>
            }
          />

          {useProfileStore.getState().profile?.level === "admin" && (
            <UserSelector
              label={lang.contact_lists.copy_to_user.dialog.user}
              placeholder={lang.contact_lists.copy_to_user.dialog.user}
              value={user}
              onChange={setUser}
              withUnswitchedProfile
              required
              withinPortal={true}
              name="user_id"
              withSelf
            />
          )}

          <Button
            type="submit"
            loading={loading}
            radius={"md"}
            size="md"
            mt={"auto"}
          >
            Voir les statistiques
          </Button>
        </Group>
      </Paper>

      {result && (
        <Paper p={"lg"} component={Stack} mt={8}>
          <Text size="lg">
            Nombre total "Edges Count" : <b>{result.totals.edges_count}</b>
          </Text>
          <Text size="lg">
            Nombre d'enrichissement total : <b>{result.totals.enrich_count}</b>
          </Text>
          <Text size="lg">
            Nombre d'enrichissement Email total :{" "}
            <b>{result.totals.enrich_email_count}</b>
          </Text>
          <Text size="lg">
            Nombre de "Resolve URL" total :{" "}
            <b>{result.totals.resolve_urls_count}</b>
          </Text>
        </Paper>
      )}
    </Stack>
  );
};

export default EnrichUsage;
